document.addEventListener("DOMContentLoaded", function () {
  var elements = document.querySelectorAll(".article-heading.text-left");
  var elements_title_white = document.querySelectorAll(
    ".t4s-section-inner.t4s_nt_se_template--18269241409756__custom_liquid_zxw6x4.t4s_se_template--18269241409756__custom_liquid_zxw6x4.t4s-container-wrap"
  );
  elements.forEach(function (element) {
    element.style.display = "none";
  });
  elements_title_white.forEach(function (element) {
    element.style.setProperty("--mgtb-bottom", "0px");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const headers = document.querySelectorAll(
    ".article-content.halo-text-format h1, .article-content.halo-text-format h2"
  );
  const outlineContainer = document.createElement("div");
  outlineContainer.classList.add("outline");

  let outlineHTML = `
        <div class="outline-table-content">
            Table of Content
            <button id="toggle-outline" class="toggle-button">
                <i class="fa fa-chevron-down"></i>
            </button>
        </div>
    `;

  headers.forEach((header, index) => {
    const id = `title-${index + 1}`;
    header.id = id;
    const text = header.textContent;
    outlineHTML += `<div class="outline-item">
                            <a href="#${id}">${text}</a>
                        </div>`;
  });

  outlineContainer.innerHTML = outlineHTML;
  document.body.insertBefore(outlineContainer, document.body.firstChild);

  const toggleButton = document.getElementById("toggle-outline");
  const outlineItems = document.querySelectorAll(".outline-item");

  toggleButton.addEventListener("click", () => {
    let isCollapsed = toggleButton.classList.contains("collapsed");
    outlineItems.forEach((item) => {
      item.style.display = isCollapsed ? "block" : "none";
    });
    toggleButton.classList.toggle("collapsed");
    toggleButton.innerHTML = isCollapsed
      ? '<i class="fa fa-chevron-up"></i>'
      : '<i class="fa fa-chevron-down"></i>';
  });

  const outlineLinks = document.querySelectorAll(".outline-item a");
  let currentActiveIndex = -1;

  function updateActiveOutline() {
    let newActiveIndex = -1;
    headers.forEach((header, i) => {
      const rect = header.getBoundingClientRect();
      const isInView = rect.top <= 10 && rect.bottom >= 0;

      if (isInView) {
        newActiveIndex = i;
      }
    });
    if (newActiveIndex !== -1) {
      currentActiveIndex = newActiveIndex;
    }
    outlineLinks.forEach((item, i) => {
      if (i === currentActiveIndex) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  }

  window.addEventListener("scroll", updateActiveOutline);
  updateActiveOutline();
});

document
  .getElementById("calculateButton")
  .addEventListener("click", function () {
    const length = parseFloat(document.getElementById("lighting-length").value);
    const width = parseFloat(document.getElementById("lighting-width").value);
    const height = parseFloat(document.getElementById("lighting-height").value);
    const lightType = document.getElementById("lightType").value;
    const usage = document.getElementById("usage").value;

    const lightLumens = {
      "100-adjustable": 14000,
      "150-adjustable": 21000,
      "200-adjustable": 28000,
      "240-adjustable": 33600,
      "400-adjustable": 60000,
      "150-hb-black": 24000,
      "150-hb-white": 24000,
      "200-hb-black": 32000,
      "200-hb-white": 32000,
      "240-hb-black": 36000,
      "240-hb-white": 36000,
      "300-hb": 42000,
      "150-super": 24000,
      "200-super": 32000,
      "100-eco": 11000,
      "150-eco": 16500,
      "150-ufo": 16500,
      "130-linear": 19500,
      "210-linear": 31500,
      "300-linear": 45000,
    };

    const luxValues = {
      Bedroom: 200,
      "Living Room": 200,
      Kitchen: 500,
      Study: 750,
      Bathroom: 500,
      "Office Work Area": 500,
      "Conference Room": 500,
      "Reception Area": 300,
      "Retail Stores": 1000,
      Restaurants: 100,
      Warehouse: 300,
      "General Manufacturing": 500,
      "Fine Work Inspection": 1000,
      "Assembly Line": 750,
      Classrooms: 500,
      Laboratories: 1000,
      "Hospital Wards": 300,
      "Operating Rooms": 2000,
      "Parking Lots": 100,
      Sidewalks: 200,
      "Sports Fields": 1000,
    };

    if (
      isNaN(length) ||
      length <= 0 ||
      isNaN(width) ||
      width <= 0 ||
      isNaN(height) ||
      height <= 0
    ) {
      document.getElementById("lighting-result").innerText =
        "Please enter valid dimensions.";
      return;
    }

    const lightChoice = document.getElementById("lightType").value;
    const usageChoice = document.getElementById("usage").value;

    const volume = length * width;
    const maxLux = luxValues[usageChoice];
    const totalLumensNeeded = (volume * maxLux) / 10;
    const lumensPerLight = lightLumens[lightChoice];

    let lightsNeeded = Math.ceil(totalLumensNeeded / lumensPerLight);

    const lightsFactor = {
      10: 1.1,
      15: 1.2,
      20: 1.3,
      25: 1.4,
      30: 1.5,
      35: 1.6,
      40: 1.7,
      45: 1.8,
    };

    const threshold = Object.keys(lightsFactor).find(
      (key) => height >= key && height < parseInt(key) + 5
    );
    if (threshold) {
      lightsNeeded = Math.ceil(lightsNeeded * lightsFactor[threshold]);
    }

    function isPrime(num) {
      if (num <= 1) return false;
      if (num === 2) return true;
      for (let i = 2; i <= Math.sqrt(num); i++) {
        if (num % i === 0) return false;
      }
      return true;
    }

    if (isPrime(Math.ceil(lightsNeeded))) {
      lightsNeeded += 1;
    }

    document.getElementById(
      "lighting-result"
    ).innerText = `Number of lights needed: ${lightsNeeded}`;

    // Show the product link button
    const productLinkButton = document.getElementById("productLinkButton");
    productLinkButton.style.display = "block";

    // Set the product link based on lightType
    const productLinks = {
      "100-adjustable":
        "https://ggjia-led.com/products/high-bay-led-lights-100w",
      "100-beta": "https://ggjia-led.com/products/low-bay-led-lights-100w",
      "150-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-150w",
      "150-hb-black":
        "https://ggjia-led.com/products/ufo-led-high-bay-light-150w",
      "150-hb-white": "https://ggjia-led.com/products/led-ufo-high-bay-150w",
      "150-alpha":
        "https://ggjia-led.com/products/ufo-high-bay-led-lights-150w",
      "150-beta": "https://ggjia-led.com/products/ufo-led-high-bay-150w",
      "150-ufo": "https://ggjia-led.com/products/ufo-led-high-bay-light",
      "150-eco": "https://ggjia-led.com/products/ufo-shop-lights-150w",
      "200-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-200w",
      "200-hb-black": "https://ggjia-led.com/products/ufo-led-lights-200w",
      "200-hb-white":
        "https://ggjia-led.com/products/high-bay-led-shop-lights-200w",
      "200-alpha": "https://ggjia-led.com/products/high-bay-shop-lights-200w",
      "240-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-240w",
      "240-hb-black":
        "https://ggjia-led.com/products/high-bay-led-shop-lights-240w",
      "240-hb-white":
        "https://ggjia-led.com/products/ufo-led-high-bay-light-240w",
      "300-hb-black": "https://ggjia-led.com/products/led-warehouse-lighting",
      "300-adjustable": "https://ggjia-led.com/products/high-bay-led-lights-300w",
      "400-adjustable":
        "https://ggjia-led.com/products/high-bay-led-lights-400w",
      "130-linear":
        "https://ggjia-led.com/products/led-linear-high-bay-shop-lights",
      "210-linear": "https://ggjia-led.com/products/linear-high-bay-shop-light",
      "300-linear": "https://ggjia-led.com/products/led-linear-high-bay-lights",
    };

    if (productLinks && productLinks[lightType]) {
      productLinkButton.href = productLinks[lightType];
      productLinkButton.onclick = function () {
        window.location.href = productLinks[lightType];
      };
    } else {
      console.error("Invalid lightType or productLinks");
    }
  });

function openPopup() {
  document.getElementById("custom-popup").style.display = "block";
  document.getElementById("custom-overlay").style.display = "block";
}

document.getElementById("closePopup").addEventListener("click", function () {
  document.getElementById("custom-popup").style.display = "none";
  document.getElementById("custom-overlay").style.display = "none";
});

// 在调用前添加null检查
const okButton = document.getElementById("okButton");

if (okButton) {
  okButton.addEventListener("click", function () {
    const popup = document.getElementById("custom-popup");
    const overlay = document.getElementById("custom-overlay");
    
    if (popup) popup.style.display = "none";
    if (overlay) overlay.style.display = "none";
  });
}
